import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Globe, Check, ChevronDown } from 'lucide-react';
import { LANGS, ROUTE_SLUGS, findRouteKey } from '@/i18n/routes';
import { useLang } from '@/i18n/LanguageContext';

export default function LanguageSelector() {
  const { lang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  const switchLang = (code) => {
    localStorage.setItem('rt_lang', code);
    const parts = pathname.split('/').filter(Boolean);
    const rest = parts.slice(1).join('/');
    const key = findRouteKey(parts[0], rest);
    let target = `/${code}`;
    if (key) {
      const slug = ROUTE_SLUGS[code][key];
      target = `/${code}${slug ? '/' + slug : ''}`;
    }
    setOpen(false);
    navigate(target);
  };

  const current = LANGS.find((l) => l.code === lang);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="header-lang-selector"
        onClick={() => setOpen(!open)}
        aria-label="Selecionar idioma"
        className="inline-flex items-center gap-1.5 rounded-full border border-brand-line bg-white px-3 py-2 text-[13px] font-semibold text-brand-navy transition hover:border-brand-blue"
      >
        <Globe className="h-4 w-4 text-brand-blue" />
        <span className="hidden sm:inline">{current ? current.short : lang}</span>
        <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div data-testid="lang-dropdown" className="absolute right-0 top-full z-50 mt-2 w-52 overflow-hidden rounded-xl border border-brand-line bg-white py-1 shadow-xl">
          {LANGS.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => switchLang(l.code)}
              className="flex w-full items-center justify-between px-4 py-2.5 text-left text-[13px] font-medium text-brand-navy transition hover:bg-brand-ice"
            >
              <span>{l.label}</span>
              {l.code === lang && <Check className="h-4 w-4 text-brand-blue" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}